<footer role="contentinfo" aria-label="페이지 바닥글">
  <div class="footer-inner">
    <span class="copyright">© 2025 S&D Smart Factory System</span>
    <span class="divider" aria-hidden="true">—</span>
    <span class="maintain">All rights reserved. <span class="dot">•</span> Developed &amp; Maintained by
      <a class="devlink" href="http://logtics.co.kr/" target="_blank" rel="noopener noreferrer"><strong>LOGTICS</strong></a>
    </span>
  </div>
</footer>

<style>
  footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: calc(10px + env(safe-area-inset-bottom)) 16px 10px;
    background-color: #f1f3f5;
    border-top: 1px solid rgba(0,0,0,0.06);
    box-sizing: border-box;
    z-index: 1000;
  }

  .footer-inner {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 6px 10px;
    text-align: center;
    line-height: 1.2;
  }

  .footer-inner > * {
    display: inline-block;
    vertical-align: middle;
  }

  .copyright,
  .maintain {
    font-size: 13px;
    color: #374151;
    white-space: normal;
  }

  .divider {
    color: #9ca3af;
    margin: 0 6px;
    font-size: 13px;
  }

  .dot {
    display: inline-block;
    margin: 0 6px;
    color: #9ca3af;
  }

  a.devlink {
    color: inherit;
    text-decoration: none;
    margin-left: 6px;
  }

  a.devlink strong {
    color: #b700ff;
  }

  @media (max-width: 480px) {
    .copyright,
    .maintain {
      font-size: 12px;
    }
    .footer-inner {
      gap: 4px 6px;
      padding-bottom: calc(env(safe-area-inset-bottom) / 2);
    }
    .divider { display: none; }
    .dot { display: inline-block; } 
  }

  @media (max-width: 340px) {
    .footer-inner { 
      justify-content: center;
    }
    .maintain { 
      width: 100%;
    }
  }
</style>
